import { ref, } from 'vue';
import { PmsAccess } from '@/classes/DbAccess/PmsAccess.js';

// global
class SearchBooking extends PmsAccess {
  constructor(pms_response) {
    super(pms_response);
    
    this.bookings = ref([]);
    this.current_data = ref({});
    
    this.search_by = '';
    this.search_target = '';
    // 2025 09 13 t_field
    this.userrole = 'user';

  }

  // 2025 09 12 t_field
  set_userrole(role) { this.userrole = role;}


  reset_data() { this.bookings.value = []; }
  get_data() { return this.bookings.value; }
  
  set_current_data(index) {
    this.current_data.value = this.bookings.value[index];
  }  
  
  get_current_data() {
    return this.current_data.value;
  }  
  
  async fetch_booking(method, target) {
    this.search_by = method;
    this.search_target = target;
    this.refetch();
  }

  // fetch with saved path and body
  async refetch() {
    /* 2025 09 15 t_field
    switch (this.search_by) {
      case 'mostrecent':     await this.fetch_pms('Bookings', "mostrecent", ""); break;
      case 'byname':         await this.fetch_pms('Bookings', "byname", this.search_target); break;
      case 'bydate':         await this.fetch_pms('Bookings', "bydate", this.search_target); break;
    }*/

    // 2025 09 15
    switch (this.search_by) {
      case 'mostrecent':     await this.fetch_pms('Bookings', "mostrecent", "", this.userrole); break;
      case 'byname':         await this.fetch_pms('Bookings', "byname", this.search_target, this.userrole); break;
      case 'bydate':         await this.fetch_pms('Bookings', "bydate", this.search_target, this.userrole); break;
    }

    // now the server response is stored in pms_response
    if (this.pms_response.type=='success')
        this.bookings.value = this.pms_response.response;
  }
  async fetch_most_recent() {
    // 2025 09 15 t_field await this.fetch_pms('Bookings', "mostrecent", "");
    await this.fetch_pms('Bookings', "mostrecent", "", this.userrole);
  }
  //ok
  async fetch_search_byname(data) {   // data=targetname    (STRING)
    // 2025 09 15 t_field await this.fetch_pms('Bookings', "byname", data);
    // 2025 09 15 t_field
    await this.fetch_pms('Bookings', "byname", data, this.userrole);
  }
  //ok
  async fetch_search_bydate(data) {   // data=targetdate   (STRING)
    // 2025 09 15 t_field await this.fetch_pms('Bookings', "bydate", data);
    await this.fetch_pms('Bookings', "bydate", data, this.userrole);
  }
  
  set_search_result_title(search_by) {
    switch (search_by) {
      case 'mostrecent': return 'Most Recent';
      case 'byname': return 'Search By Name';
      case 'bydate': return 'Searcy By Check-in Date';
    }
  }  

  
}

export let searchbooking = new SearchBooking();
